import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./navbar.css";
import CompanyLogo from "../../Assets/Images/hudson-logo.png";
import UserIcon from "../../Assets/Icons/UserIcon";
import HamburgerIcon from "../../Assets/Icons/HamburgerIcon";
import { useNewUser } from "../../APIContext/NewUserContext";
import { Menubar } from "primereact/menubar";
import { Sidebar } from "primereact/sidebar";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const NavbarCustom = () => {
  const navigate = useNavigate();
  const { fetchCartCount, cartRe, loading } = useNewUser();
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const location = useLocation();
  const external_link = "";

  const [user, setUser] = useState("");
  // Menu items when NOT logged in
  const menuItemsGuestDesktop = [
    {
      label: "Home",
      command: () => {
        setSidebarVisible(false);
        window.location.href = "https://hudsontransitions.com/";
      },
    },
    {
      label: "About Us",
      command: () => {
        setSidebarVisible(false);
        window.location.href = "https://hudsontransitions.com/about/";
      },
    },
    {
      label: "Listings",
      template: () => (
        <Link to="/" onClick={() => setSidebarVisible(false)}>
          Listings
        </Link>
      ),
    },
    {
      label: "Services",
      command: () => {
        setSidebarVisible(false);
        window.location.href = "https://hudsontransitions.com/services/";
      },
    },
    {
      label: "Resources",
      command: () => {
        setSidebarVisible(false);
        window.location.href = "https://hudsontransitions.com/resources/";
      },
    },
    {
      label: "Contact",
      command: () => {
        setSidebarVisible(false);
        window.location.href = "https://hudsontransitions.com/contact/";
      },
    },
  ];

  // Menu items when NOT logged in
  const menuItemsGuestMobile = [
    {
      label: "Home",
      command: () => {
        setSidebarVisible(false);
        window.location.href = "https://hudsontransitions.com/";
      },
    },
    {
      label: "About Us",
      command: () => {
        setSidebarVisible(false);
        window.location.href = "https://hudsontransitions.com/about/";
      },
    },
    {
      label: "Listings",
      template: () => (
        <Link to="/" onClick={() => setSidebarVisible(false)}>
          Listings
        </Link>
      ),
    },
    {
      label: "Services",
      command: () => {
        setSidebarVisible(false);
        window.location.href = "https://hudsontransitions.com/services/";
      },
    },
    {
      label: "Resources",
      command: () => {
        setSidebarVisible(false);
        window.location.href = "https://hudsontransitions.com/resources/";
      },
    },
    {
      label: "Contact",
      command: () => {
        setSidebarVisible(false);
        window.location.href = "https://hudsontransitions.com/contact/";
      },
    },
  ];

  // Logo
  const start = (
    <Link to="/" onClick={() => setSidebarVisible(false)}>
      <img src={CompanyLogo} alt="Logo" className="navbar-logo" />
    </Link>
  );

  // Right side (login button or icons + hamburger)
  const mobileEnd =
    !user || (user && user.role !== "PARENT") ? (
      <div className="navbar-icons">
        <button
          className="nav-icon hamburger-icon"
          onClick={() => setSidebarVisible(true)}
        >
          <HamburgerIcon />
        </button>
      </div>
    ) : (
      <div className="navbar-icons">
        <button
          className="nav-icon hamburger-icon"
          onClick={() => setSidebarVisible(true)}
        >
          <HamburgerIcon />
        </button>
      </div>
    );

  // Right side (login button or icons + hamburger)
  const deskEnd =
    !user || (user && user.role !== "PARENT") ? (
      <div className="navbar-icons">
        {/* <Link
          to="/login"
          className="register-login-btn"
          onClick={() => setSidebarVisible(false)}
        >
          Sign Up / Login
        </Link> */}
      </div>
    ) : (
      <div className="navbar-icons">
        <Link
          to="/profile"
          className="nav-icon"
          onClick={() => setSidebarVisible(false)}
        >
          <UserIcon className="nav-icon" />
        </Link>
      </div>
    );

  return (
    <nav className="section-full-w-row navbar-container">
      <div className="section-boxed-w-row">
        {/* Desktop Navbar */}
        <div className="desktop-navbar">
          <Menubar
            model={menuItemsGuestDesktop}
            start={start}
            end={deskEnd}
            className={"not-login-menubar"}
          />
        </div>

        <div className="mobile-header-bar">
          {start}
          {mobileEnd}
        </div>

        <Sidebar
          visible={sidebarVisible}
          position="right"
          onHide={() => setSidebarVisible(false)}
          className="mobile-sidebar"
        >
          <div className="mobile-sidebar-header">
            {start}
            <button
              className="close-btn"
              onClick={() => setSidebarVisible(false)}
            >
              ✕
            </button>
          </div>

          <Menubar model={menuItemsGuestMobile} className="not-login-menubar" />
        </Sidebar>
      </div>
    </nav>
  );
};

export default NavbarCustom;
